<template>
    <article class="article-wrapper article1">
        <h1 class="title lg-title fade2"
        :class="{'active': $parent.isfadeInActive}"
        v-html="formatTitle(data.title)">致全台灣人的返校通知</h1>
        <div class="photo-wrapper fade3"
        :class="{'active': $parent.isfadeInActive}"
        :style="[data.youtube ? '' : {cursor: 'default'}]"
        @click.prevent="data.youtube ? popup() : null">
            <img :src="data.image_path"
            class="photo"
            v-if="!data.is_video && data.image_path" />
            <video ref="section1Video" width="100%" height="100%"
            style="position: absolute;left: 0;top: 0;" muted preload loop playsinline
            v-if="data.is_video && (data.video_path || data.video_mob_path)">
                <source v-if="!isPc && data.video_mob_path"
                :src="data.video_mob_path" type="video/mp4">
                <source v-else :src="data.video_path" type="video/mp4">
            </video>
            <img src="@/assets/images/article7/img_photo_default@3x.png"
            class="photo" style="opacity: 0;" v-if="data.is_video"/>
            <span
            v-if="data.youtube"
            class="video-btn">
            </span>
        </div>
        <div class="text-wrapper">
            <h2 id="article1Title" class="title fade3"
            :class="{'active': $parent.isfadeInActive}"
            v-text="data.sub_title">你是忘記了，還是不敢來</h2>
            <div class="info-wrapper fade4"
            :class="{'active': $parent.isfadeInActive}">
                <p class="source">
                    【發布單位／{{data.title_unit}}】
                    <a href="" title="FB分享" class="fb-btn"
                    @click.prevent="onShare('fb', data.share_link);
                    gaEvent('share_fb', 'frontpg_sharefb');">
                        <img src="@/assets/images/btn_article_fb_n@3x.png" />
                    </a>
                    <a href="" title="Line分享" class="line-btn"
                    @click.prevent="onShare('line', data.share_link_line, data.line_text);
                    gaEvent('share_line', 'frontpg_shareline');">
                        <img src="@/assets/images/btn_article_line_n@3x.png" />
                    </a>
                </p>
                <p>日期：{{data.title_date}}</p>
                <p>地點：{{data.title_place}}</p>
                <p>對象：{{data.title_target}}</p>
            </div>
            <p class="description fade5"
            :class="{'active': $parent.isfadeInActive}" v-html="data.content">
                本校特舉辦「返校實境體驗展」，真實還原遊戲中的翠華中學場景，
                你將化身讀書會成員，進入女主角方芮欣的輪迴，親臨結合場景、演員、聲音、光影、氣味，如「鬼屋探險」般的恐懼氛圍……你，有膽量返校尋找真相嗎？
            </p>
            <div class="text-center fade6"
            :class="{'active': $parent.isfadeInActive}">
                <a :href="data.link"
                @click="gaEvent('buy_btn', 'frontpg_buy');"
                target="_blank"
                class="ticket-btn">
                    <img :src="data.link_image"/>
                </a>
            </div>
        </div>
        <Youtube
        :show="isOpen" :youtube="data.youtube" />
    </article>
</template>

<script>
import Youtube from '@/components/Youtube.vue';
import mixinMethod from '@/js/mixin/mixinMethod';


export default {
    name: 'coverstory1',
    props: {
        data: {
            type: Object,
            default() {
                return {
                    title: '',
                    sub_title: '',
                    title_unit: '',
                    title_date: '',
                    title_place: '',
                    title_target: '',
                    content: '',
                    link: '',
                    youtube: '',
                    image_path: '',
                    share_link: '',
                };
            },
        },
        isPlayHeader: {
            type: Boolean,
        },
        isPc: {
            type: Boolean,
        },
    },
    data() {
        return {
            gaCategory: '',
            isOpen: false,
            limitTimes: 200,
            times: 0,
            isCreateCanvas: false,
        };
    },
    computed: {
    },
    mounted() {
    },
    methods: {
        popup() {
            this.isOpen = !this.isOpen;
            if (this.isOpen) {
                this.$parent.cancelOtherMusic('youtubeMusic');
                if (this.targetIdx === 1) {
                    this.$parent.cancelOtherMusic('tvVideo');
                }
            } else {
                this.$parent.volBgMusic(1);
            }
        },
        onShare(kind, url, lineText) {
            this.$parent.onShare(kind, url, lineText);
        },
    },
    watch: {
        isPlayHeader(val) {
            const video = this.$refs.section1Video;
            if (val) {
                window.setTimeout(() => {
                    if (video) video.play();
                }, 500);
                return;
            }
            if (video) {
                video.pause();
                video.currentTime = 0;
            }
        },
        'data.video_path': {
            handler() {
                // console.log(this.isPlayHeader);
                if (this.isPlayHeader) {
                    window.onload = () => {
                        const video = this.$refs.section1Video;
                        if (video && video.paused) {
                            window.setTimeout(() => {
                                if (video) video.play();
                            }, 500);
                        }
                    };
                }
            },
            deep: true,
            immediate: true,
        },
        'data.video_mob_path': {
            handler() {
                // console.log(this.isPlayHeader);
                if (this.isPlayHeader) {
                    window.onload = () => {
                        const video = this.$refs.section1Video;
                        if (video && video.paused) {
                            window.setTimeout(() => {
                                if (video) video.play();
                            }, 500);
                        }
                    };
                }
            },
            deep: true,
            immediate: true,
        },
    },
    mixins: [mixinMethod],
    components: {
        Youtube,
    },
};
</script>
